import Link from "next/link";

import { Collapse, RotatingChevron } from "@newsela/angelou";
import PropTypes from "prop-types";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import {
  dropdownChildrenItemsCss,
  dropdownContentCss,
  dropdownContentWithReadingSkillCss,
  dropdownIconCss,
  readingSkillAndChevronContainerCss,
  readingSkillTitleCss,
  standardCollapseCss,
  standardDescriptionCss,
  standardElementCss,
  standardElementWithReadingSkillCss,
  standardLinkCss,
} from "./QuizElaStandardsDropdown.style";

const propTypes = {
  id: PropTypes.string,
  readingSkillTitle: PropTypes.string,
  standard: PropTypes.object,
};

const QuizElaStandardsDropdown = ({
  id,
  readingSkillTitle = null,
  standard,
}) => {
  if (!standard) return null;

  const buttonContents = (isHidden, timeout) => {
    if (readingSkillTitle) {
      return (
        <div css={dropdownContentWithReadingSkillCss}>
          <b
            css={standardElementWithReadingSkillCss}
          >{`${standard.standard_title}: `}</b>
          <div css={readingSkillAndChevronContainerCss}>
            <p css={readingSkillTitleCss}>{readingSkillTitle}</p>
            <RotatingChevron
              __cssFor={{ root: dropdownIconCss }}
              isDown={isHidden}
              timeout={timeout}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div css={dropdownContentCss}>
          <b css={standardElementCss}>{standard.standard_title}</b>
          <RotatingChevron
            __cssFor={{ root: dropdownIconCss }}
            isDown={isHidden}
            timeout={timeout}
          />
        </div>
      );
    }
  };

  return (
    <Collapse
      __cssFor={{
        root: standardCollapseCss,
      }}
      buttonProps={{
        __cssFor: {
          root: standardCollapseCss,
        },
      }}
      renderButtonContents={(isHidden, timeout) =>
        buttonContents(isHidden, timeout)
      }
    >
      <div css={dropdownChildrenItemsCss}>
        <span css={standardDescriptionCss}>
          {standard.standard_description}
        </span>
        <Link
          href={`${MONOLITH_ORIGIN}/search/?standards=${id}`}
          passHref
          legacyBehavior
        >
          <a css={standardLinkCss} target="_blank" rel="noopener noreferrer">
            View standard
          </a>
        </Link>
      </div>
    </Collapse>
  );
};

QuizElaStandardsDropdown.propTypes = propTypes;

export default QuizElaStandardsDropdown;
